import { render, staticRenderFns } from "./water.vue?vue&type=template&id=49f76fe0&scoped=true&"
import script from "./water.vue?vue&type=script&lang=js&"
export * from "./water.vue?vue&type=script&lang=js&"
import style0 from "./water.vue?vue&type=style&index=0&id=49f76fe0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f76fe0",
  null
  
)

export default component.exports